import {
  IPubsub_Subscription_Status_Connecting,
  IPubsub_Subscription_Status_Connected,
  IPubsub_Subscription_Status_Error,

  IPubsub_HandlerType_Ping,
  IPubsub_HandlerType_Pong,
  IPubsub_HandlerType_Command,
  IPubsub_HandlerType_Subscribe,
  IPubsub_HandlerType_Subscribe_Success,
  IPubsub_HandlerType_Subscribe_Error,
  IPubsub_HandlerType_Unsubscribe,
  IPubsub_HandlerType_Read,
  IPubsub_HandlerType_Write,
  IPubsub_HandlerType_Error,

  IPubsub_Message_Type_Test,
  
  IPubsub_Message_Type_Job_Log,
  IPubsub_Message_Type_Job_Update,
  IPubsub_Command_Type_Job_Get,

  IPubsub_Message_Type_Crm_Import_Event,
  IPubsub_Message_Type_Astonish_Campaign_Event,
  IPubsub_Message_Type_Astonish_Template_Event,
  IPubsub_Message_Type_Support_Message,
  IPubsub_Message_Type_Knowledgebase_Article_Event,
  IPubsub_Message_Type_Marketing_Post_Event,
  IPubsub_Message_Type_Nopress_Publish_Event,
  
} from '../types/pubsub'


/*

  pubsub

*/

// when we subscribe - this is the delay between
// checks as to whether our subscription was successful
export const PUBSUB_SUBSCRIPTION_LOOP_DELAY = 100

// how long we wait to get confirmation or error
// for a subscription (in ms)
export const PUBSUB_SUBSCRIPTION_LOOP_TIMEOUT = 1000 * 5

// how often do we issue a "get_job" command down the websocket
// whilst we are waiting for the job to complete
export const PUBSUB_WAIT_FOR_JOB_POLLING_INTERVAL = 1000 * 5

// how often we check for the job status within the loop
export const PUBSUB_WAIT_FOR_JOB_CHECK_INTERVAL = 100

export const PUBSUB_SUBSCRIPTION_STATUS_CONNECTING: IPubsub_Subscription_Status_Connecting = 'connecting'
export const PUBSUB_SUBSCRIPTION_STATUS_CONNECTED: IPubsub_Subscription_Status_Connected = 'connected'
export const PUBSUB_SUBSCRIPTION_STATUS_ERROR: IPubsub_Subscription_Status_Error = 'error'

/*

  handler types

*/
export const PUBSUB_HANDLER_TYPE_PING: IPubsub_HandlerType_Ping = 'ping'
export const PUBSUB_HANDLER_TYPE_PONG: IPubsub_HandlerType_Pong = 'pong'
export const PUBSUB_HANDLER_TYPE_COMMAND: IPubsub_HandlerType_Command = 'command'
export const PUBSUB_HANDLER_TYPE_SUBSCRIBE: IPubsub_HandlerType_Subscribe = 'subscribe'
export const PUBSUB_HANDLER_TYPE_SUBSCRIBE_SUCCESS: IPubsub_HandlerType_Subscribe_Success = 'subscribe_success'
export const PUBSUB_HANDLER_TYPE_SUBSCRIBE_ERROR: IPubsub_HandlerType_Subscribe_Error = 'subscribe_error'
export const PUBSUB_HANDLER_TYPE_UNSUBSCRIBE: IPubsub_HandlerType_Unsubscribe = 'unsubscribe'
export const PUBSUB_HANDLER_TYPE_READ: IPubsub_HandlerType_Read = 'read'
export const PUBSUB_HANDLER_TYPE_WRITE: IPubsub_HandlerType_Write = 'write'
export const PUBSUB_HANDLER_TYPE_ERROR: IPubsub_HandlerType_Error = 'error'

/*

  message types

*/
export const PUBSUB_MESSAGE_TYPE_TEST: IPubsub_Message_Type_Test = 'test'

/*

  job

*/
export const PUBSUB_MESSAGE_TYPE_JOB_LOG: IPubsub_Message_Type_Job_Log = 'job_log'
export const PUBSUB_MESSAGE_TYPE_JOB_UPDATE: IPubsub_Message_Type_Job_Update = 'job_update'
export const PUBSUB_COMMAND_TYPE_JOB_GET: IPubsub_Command_Type_Job_Get = 'job_get'

/*

  crm

*/
export const PUBSUB_MESSAGE_TYPE_CRM_IMPORT_EVENT: IPubsub_Message_Type_Crm_Import_Event = 'crm_import_event'

/*

  astonish

*/
export const PUBSUB_MESSAGE_TYPE_ASTONISH_CAMPAIGN_EVENT: IPubsub_Message_Type_Astonish_Campaign_Event = 'astonish_campaign_event'
export const PUBSUB_MESSAGE_TYPE_ASTONISH_TEMPLATE_EVENT: IPubsub_Message_Type_Astonish_Template_Event = 'astonish_template_event'

/*

  knowledgebase

*/
export const PUBSUB_MESSAGE_TYPE_KNOWLEDGEBASE_ARTICLE_EVENT: IPubsub_Message_Type_Knowledgebase_Article_Event = 'knowledgebase_article_event'

/*

  marketing

*/
export const PUBSUB_MESSAGE_TYPE_MARKETING_POST_EVENT: IPubsub_Message_Type_Marketing_Post_Event = 'marketing_post_event'


/*

  nopress

*/
export const PUBSUB_MESSAGE_TYPE_NOPRESS_PUBLISH_EVENT: IPubsub_Message_Type_Nopress_Publish_Event = 'nopress_publish_event'


/*

  support

*/
export const PUBSUB_MESSAGE_TYPE_SUPPORT_MESSAGE: IPubsub_Message_Type_Support_Message = 'support_message'

